// // eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
// import { ObjectId as ObjectIdImpl } from 'bson'

// // here we can import the ObjectId from mongodb
// // eslint-disable-next-line no-restricted-imports
// import type { ObjectId as ObjectIdType } from 'mongodb'

// export const ObjectId: typeof ObjectIdType = ObjectIdImpl
// export const isObjectId = (objectId: string) => {
//     return ObjectId.isValid(objectId)
// }
// export declare type ObjectId = ObjectIdType

// eslint-disable-next-line import/no-extraneous-dependencies
import { ObjectId } from 'bson'

export const isObjectId = (value: any) => {
    if (!value) {
        return false
    }

    if (typeof value === 'string') {
        return ObjectId.isValid(value)
    }

    if (
        // eslint-disable-next-line no-restricted-syntax
        value instanceof ObjectId ||
        value._bsontype === 'ObjectID' ||
        value._bsontype === 'ObjectId'
    ) {
        return true
    }

    return false
}

export const asObjectId = (value: ObjectId | string) => {
    // eslint-disable-next-line no-restricted-syntax
    if (value instanceof ObjectId) {
        return value
    }

    return new ObjectId(value)
}

export const isObjectIdInstance = (value: any): value is ObjectId => {
    if (!value) {
        return false
    }

    if (
        // eslint-disable-next-line no-restricted-syntax
        value instanceof ObjectId ||
        value._bsontype === 'ObjectID' ||
        value._bsontype === 'ObjectId'
    ) {
        return true
    }

    return false
}

export { ObjectId }
